import { Injectable, NgZone } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable, Subject } from 'rxjs';

export interface SseEvent {
  type: string;
  project_id?: number | string;
  step?: string;
  progress?: number;
  message?: string;
  result_url?: string;
}

@Injectable({ providedIn: 'root' })
export class VideoManagementSseService {
  private eventSource: EventSource | null = null;
  private messageSubject = new Subject<SseEvent>();
  public message$: Observable<SseEvent> = this.messageSubject.asObservable();

  private baseUrl = environment.pythonUrl;
  private isConnected = false;  // 중복연결 방지 상태값
  private sessionId: string | null = null;

  constructor(private ngZone: NgZone) {}

  connect(sessionId: string): void {
    if (this.isConnected && this.sessionId === sessionId) {
      console.log('VideoManagementSseService SSE 이미 연결되어 있음, 재연결하지 않음');
      return;
    }
    this.disconnect();
    
    // if (this.eventSource) {
    //   console.log('SSE already connected');
    //   return;
    // }

    this.sessionId = sessionId;

    const url = `${this.baseUrl}/v1/SSE/notify/events/manage?session_id=${encodeURIComponent(sessionId)}`;
    console.log('Connecting SSE to:', url);
    this.eventSource = new EventSource(url);

    this.eventSource.onopen = () => {
      console.log('VideoManagementSseService SSE 연결 성공:', url);
      this.isConnected = true;
    };

    this.eventSource.onmessage = (event) => {
      try {
        const parsedData: SseEvent = JSON.parse(event.data);
        this.ngZone.run(() => {
          this.messageSubject.next(parsedData);
        });
      } catch (e) {
        console.error('VideoManagementSseService SSE 데이터 파싱 오류:', e);
      }
    };

    this.eventSource.onerror = (error) => {
      console.error('VideoManagementSseService SSE 오류 발생:', error);
      this.disconnect();
      this.isConnected = false;

      // 재접속 시도
      setTimeout(() => {
        if (this.sessionId) {
          console.log('VideoManagementSseService SSE 재접속 시도 중...');
          this.connect(this.sessionId);
        }
      }, 3000);
    };
  }

  disconnect(): void {
    if (this.eventSource) {
      this.eventSource.close();
      this.eventSource = null;
      this.isConnected = false;
      console.log('SSE 연결 종료');
    }
  }
}
